<template>
  <validation-observer
    ref="userPermission"
  >
    <b-form
      method="POST"
      autocomplete="off"
      class="auth-permission-form"
      @submit.prevent="saveUserPermission"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Users Type"
            label-for="id"
          >
            <validation-provider
              #default="{ errors }"
              name="User"
              vid="vi-user"
              rules="required"
            >
              <v-select
                id="user"
                v-model="userTypeSelected"
                name="user"
                class="p-0 border-0"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                placeholder="Select"
                label="name"
                :reduce="userType => userType.adminuserid"
                :options="user"
                @input="changeUser"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </b-col>
        <b-col
          v-for="per in permission"
          :key="per.trngroupid"
          md="4"
          class="py-1"
        >
          <b-card
            class="h-100"
            :header="per.trngrouptitle"
          >

            <b-form-checkbox
              v-for="trans in per.transaction"
              :key="trans.trnid"
              v-model="permissionSelected"
              class="my-1"
              :name="per.trngrouptitle+trans.trnid"
              :value="trans.trnid"
            >
              <span> {{ trans.trnname }} </span>
            </b-form-checkbox>

          </b-card>

        </b-col>
        <!-- reset and submit -->
        <b-col
          cols="12"
          class="text-center"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
          >
            Submit
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
          >
            Reset
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BRow, BCol, BCard, BForm, BFormGroup, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import store from '../../store'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormCheckbox,
    vSelect,
    BCard,
    BButton,
    ValidationObserver,
    ValidationProvider,

  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      user: [],
      permission: [],
      userTypeSelected: '',
      permissionSelected: [],
    }
  },
  mounted() {
    store.dispatch('userPermission/getPermissionSettings')
      .then(response => {
        if (response.data.code === '200') {
          this.permission = response.data.data
        }
      })
    store.dispatch('userPermission/getUsers')
      .then(response => {
        if (response.data.code === '200') {
          this.user = response.data.data
        }
      })
  },
  methods: {
    changeUser() {
      store.dispatch('userPermission/getUserTypePermissions', { adminuserid: this.userTypeSelected })
        .then(response => {
          if (response.data.code === '200') {
            this.permissionSelected = response.data.data
          }
        })
    },
    saveUserPermission() {
      console.log('saveUserPermission clicked, validating form...');
      this.$refs.userPermission.validate().then(success => {
        console.log('Validation result:', success);
        if (success) {
          const payload = { adminuserid: this.userTypeSelected, transactionIds: this.permissionSelected };
          console.log('Sending payload:', payload);
          store.dispatch('userPermission/saveUserPermission', payload)
            .then(response => {
              console.log('Response received:', response);
              if (response.data.code === '200') {
                this.permissionSelected = response.data.data
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `${response.data.msg}`,
                    icon: 'Success',
                    variant: 'success',
                    text: '',
                  },
                })
              } else {
                console.warn('Response code is not 200:', response.data.code);
              }
            }).catch(e => {
              console.error('Promise catch error:', e);
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `${e.msg || e.message || 'Error saving permissions'}`,
                  icon: 'Danger',
                  variant: 'danger',
                  text: '',
                },
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
  .card {
    max-height: 350px;
    margin-bottom: 0;
  }
  .card-header {
    background: linear-gradient(to right , rgba(99, 99, 248, 0.199), rgba(99, 99, 248, 0.199), rgba(255, 128, 255, 0.281));
    font-weight: bold;
  }
  .card-body {
    overflow: auto;
    margin-bottom: 1.5rem;
  }
  .card-body::-webkit-scrollbar {
    display: none;
  }
</style>
